module.exports = __webpack_public_path__ + "static/header-white-4ddaf1c54fde0baa7f85478911904631.png";